import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

// For Encryption
import SecureLS from "secure-ls";

var ls = new SecureLS({ isCompression: false });

import modules from "./modules";

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  plugins: [
    createPersistedState({
      key: "spd_pos",
      // storage: {
      //   getItem: (key) => ls.get(key),
      //   setItem: (key, value) => ls.set(key, value),
      //   removeItem: (key) => ls.remove(key),
      // },
    }),
  ],
  strict: process.env.NODE_ENV !== "production",
  actions: {
    fetchAllData({ dispatch }) {
      dispatch("masterData/initialState");
      dispatch("auth/fetchUserInfo");
      dispatch("customer/fetchCustomerTypes");
      dispatch("customer/fetchCustomerGroups");

      dispatch("product/fetchProducts");
      dispatch("product/FetchAllBrands");
      dispatch("product/FetchAllCategories");
      dispatch("warehouse/fetchWarehouses");
      dispatch("supplier/fetchLedgerTypes");
      // dispatch("sales/fetchSalesInfo");
      dispatch("siteSettings/fetchSiteInfo");
    },
  },
});
